/** @typedef {import('@basqet-dashboard/common/types/payout').PayoutBeneficiary} PayoutBeneficiary */
/** @typedef {import('@basqet-dashboard/common/types/api').PaginatedResponse} PaginatedResponse */
/** @typedef {import('@basqet-dashboard/common/types/api').PaginationParams} PaginationParams */
/** @typedef {import('@basqet-dashboard/common/types/api').ApiResponse} ApiResponse */

import { API_LIMIT, instance } from '@basqet-dashboard/common/config/api';

/**
 * @param {PaginationParams & { grouped?: boolean, singles_only?: boolean }} params
 * @returns {Promise<PaginatedResponse<PayoutBeneficiary>>}
 */
const fetchAllBeneficiaries = async ({
  offset,
  searchQuery,
  dateFilter = {},
  grouped = false,
  singles_only = false
}) => {
  const { from, to } = dateFilter;
  const { data } = await instance.get(
    `payout/beneficiary?grouped=${grouped}&singles_only=${singles_only}&limit=${API_LIMIT}${
      offset ? '&offset=' + offset : ''
    }${searchQuery ? '&search_term=' + searchQuery : ''}${
      from && to ? '&from=' + from + '&to=' + to : ''
    }`
  );
  return data;
};

/**
 * @param {Partial<PayoutBeneficiary>} body
 * @returns {Promise<ApiResponse<PayoutBeneficiary>>}
 */
const createSingleBeneficiary = async (body) => {
  const { data } = await instance.post('payout/beneficiary/create', body);
  return data;
};

/**
 * @param {FormData} body
 * @returns {Promise<ApiResponse<object>>}
 */
const uploadBulkBeneficiary = async (body) => {
  const { data } = await instance.post('payout/beneficiary/bulk', body);
  return data;
};

/**
 * @param {number} beneficiaryId
 * @param {Partial<PayoutBeneficiary>} body
 * @returns {Promise<ApiResponse<PayoutBeneficiary>>}
 */
const updateSingleBeneficiary = async (beneficiaryId, body) => {
  const { data } = await instance.patch(`payout/beneficiary/update/${beneficiaryId}`, body);
  return data;
};

/**
 * @param {number} beneficiaryId
 * @returns {Promise<ApiResponse<object>>}
 */
const deleteSingleBeneficiary = async (beneficiaryId) => {
  const { data } = await instance.delete(`payout/beneficiary/${beneficiaryId}`);
  return data;
};

export {
  createSingleBeneficiary,
  deleteSingleBeneficiary,
  fetchAllBeneficiaries,
  updateSingleBeneficiary,
  uploadBulkBeneficiary
};
